import React from "react";
import { JsonLdTags } from "./JsonLd";

const RecentReviewsJsonLDWrapper = ({ merchant, reviews }) => {
  if (!reviews) {
    return null;
  }

  return <JsonLdTags merchant={merchant} reviews={reviews} />;
};

export default RecentReviewsJsonLDWrapper;



// WEBPACK FOOTER //
// ./src/components/RecentReviewsJsonLDWrapper.jsx